<template>
  <v-card>
    <v-container
      fluid
      grid-list-lg
    >
      <v-layout row wrap>

        <template v-for="item, i in items">
          <v-flex grow lg4 md6 pa-1>
            <v-card  hover @click="goToPath(item)" color=" "
                    height="350px">
              <v-img
                :src="item.src"
                contain
                flat
                max-height="180"
              >
              </v-img>
              <v-card-title primary-title>
              </v-card-title>
              <div style="text-align: center;">
                <div class="headline">
                  {{item.name}}
                </div>
                <span>
                    {{item.text}}
                  </span>
              </div>

            </v-card>
          </v-flex>
        </template>


      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    name: "Services",
    data() {
      return {
        items: [
          {
            name: 'Официальный сайт',
            text: 'Официальный сайт Российского химико-технологического университета им. Д.И. Менделеева',
            url: 'https://muctr.ru/',
            src: 'https://muctr.ru/upload/university/it-resources/Group_44.png',
            route: '',
          },
          {
            name: 'Электронная информационно-образовательная среда',
            text: 'Теперь вся информация об учебном процессе в одном месте',
            url: 'https://eios.muctr.ru/',
            src: 'https://muctr.ru/upload/university/it-resources/Group_35.png',
            route: '',
          },
          {
            name: 'Информационно-библиотечный центр',
            text: 'Информационная поддержка образовательного процесса и научно-исследовательской деятельности\n' +
              '                        университета',
            url: 'https://lib.muctr.ru',
            src: 'https://muctr.ru/upload/university/it-resources/Group_42.png',
            route: '',
          },
          {
            name: 'Оплата',
            text: 'Онлайн-сервис оплаты услуг университета',
            url: 'https://pay.muctr.ru',
            src: 'https://muctr.ru/upload/university/it-resources/Group_36.png',
            route: '',
          },
          {
            name: 'База знаний',
            text: 'Информация и инструкции пользования веб-сервисами университета',
            url: 'https://wiki.muctr.ru',
            src: 'https://muctr.ru/upload/university/it-resources/Group_30.png',
            route: '',
          },
          {
            name: 'Корпоративная почта',
            text: 'Почтовый веб-интерфейс для использования корпоративной почты',
            url: 'https://mail.muctr.ru',
            src: 'https://muctr.ru/upload/university/it-resources/Group_31.png',
            route: '',
          },
          {
            name: 'Регистрация сотрудников',
            text: 'Система регистрации почтового адреса для сотрудников университета',
            url: 'https://portal.muctr.ru/account/registration',
            src: 'https://muctr.ru/upload/university/it-resources/Group_61.png',
            route: '',
          },
          {
            name: 'Управление закупок и централизованного снабжения',
            text: 'Информационный портал управления закупок и централизованного снабжения',
            url: 'https://zakupki.muctr.ru',
            src: 'https://muctr.ru/upload/university/it-resources/Group_24.png',
            route: '',
          },
          {
            name: 'Электронная очередь',
            text: 'Оформление заявок на материальную помощь и санаторий-профилакторий',
            url: 'https://queue.muctr.ru',
            src: 'https://muctr.ru/upload/university/it-resources/Group_50.png',
            route: '',
          },
          {
            name: 'Учебный портал',
            text: 'Онлайн-поддержка курсов, читаемых в университете',
            url: 'https://moodle.muctr.ru',
            src: 'https://muctr.ru/upload/university/it-resources/Group_27.png',
            route: '',
          },

          {
            name: 'Диссертации РХТУ',
            text: ' Электронная библиотека диссертаций, защищаемых в университете',
            url: 'https://diss.muctr.ru',
            src: 'https://muctr.ru/upload/university/it-resources/Group_46.png',
            route: '',
          },

          {
            name: 'Система тестирования',
            text: ' Тестирование и оценка знаний по разным дисциплинам',
            url: 'https://exam.muctr.ru',
            src: 'https://muctr.ru/upload/university/it-resources/Group_45.png',
            route: '',
          },
          {
            name: 'Антиплагиат',
            text: 'Cистема обнаружения текстовых заимствований',
            url: 'http://antiplagiat.muctr.ru',
            src: 'https://muctr.ru/upload/university/it-resources/Group_40.png',
            route: '',
          },
          {
            name: 'Межрегиональная олимпиада',
            text: 'Химическая олимпиада школьников им. академика П.Д. Саркисова',
            url: 'http://olimp.muctr.ru',
            src: 'https://muctr.ru/upload/university/it-resources/Group_38.png',
            route: '',
          },

          {
            name: 'Олимпиады РХТУ',
            text: 'К участию в олимпиадах приглашаются студенты всех курсов университета!',
            url: 'http://olimp.muctr.ru',
            src: 'https://muctr.ru/upload/university/it-resources/Group_62.png',
            route: '',
          },

        ]

      }
    },
    methods: {
      goToPath(path) {
        if (path.url !== '')
          window.open(path.url);
        else
          this.$router.push({name: path.route})
      },

    },
    created() {
      //console.log('here');
      this.$store.commit('leftmenu/dissable');
      this.$store.commit('leftmenu/replaceItems', []);
    }
  }
</script>

<style scoped>

</style>
